// ------------------------------------------------------------------------
//
// This code is property of BioSilico Limited and is protected by
// copyright law and international treaties. Unauthorized
// reproduction or distribution of this file, or any portion of
// it may result in severe civil and criminal penalties, and will
// be prosecuted to the maximum extent possible under the law.
//
// = LIBRARY
//   HomepageJS
//
// = FILENAME
//   wasm.jsx
//
// = AUTHOR
//   Who       When        Why/What
//   K. Plewa   09.11.2022  Development
//
// ------------------------------------------------------------------------
import React, { useEffect, useRef } from "react";

const IdeaMapper = ({ wasmsrcurl, wasmemscriptenstring, wasmdir }) => {
  const scriptLoaded = useRef(false);

  useEffect(() => {
    const loadScripts = async () => {
      if (scriptLoaded.current) return;

      const loadScript = (src) => {
        return new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.src = src;
          script.async = false;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      };

      try {
        // Load IdeaMapper.js
        let scriptSRC;
        try {
          scriptSRC = eval(wasmsrcurl);
        } catch (error) {
          scriptSRC = wasmsrcurl;
          console.log(`Error: ${error}. scriptSRC: ${scriptSRC}`);
        }
        await loadScript(scriptSRC);

        // Load qtloader.js
        let emscriptenSRC;
        try {
          emscriptenSRC = eval(wasmemscriptenstring);
        } catch (error) {
          emscriptenSRC = wasmemscriptenstring;
          console.log(`Error: ${error}. emscriptenSRC: ${emscriptenSRC}`);
        }
        await loadScript(emscriptenSRC);

        // Initialize and load the WASM module using the new QT6.7 method
        async function init() {
          const spinner = document.querySelector("#qtspinner");
          const screen = document.querySelector("#screen");
          const status = document.querySelector("#qtstatus");

          const showUi = (ui) => {
            [spinner, screen].forEach(
              (element) => (element.style.display = "none")
            );
            if (screen === ui) screen.style.position = "default";
            ui.style.display = "block";
          };

          try {
            showUi(spinner);
            status.innerHTML = "Loading...";

            const instance = await window.qtLoad({
              locateFile: (filename) => {
                if (filename.endsWith(".wasm")) {
                  let wasmDir;
                  try {
                    wasmDir = eval(wasmdir);
                  } catch (error) {
                    wasmDir = wasmdir;
                    console.log(
                      `Error: ${error}. emscriptenSRC: ${emscriptenSRC}`
                    );
                  }
                  return wasmDir;
                }
                return filename;
              },
              qt: {
                onLoaded: () => showUi(screen),
                onExit: (exitData) => {
                  status.innerHTML = "Application exit";
                  status.innerHTML +=
                    exitData.code !== undefined
                      ? ` with code ${exitData.code}`
                      : "";
                  status.innerHTML +=
                    exitData.text !== undefined ? ` (${exitData.text})` : "";
                  showUi(spinner);
                },
                entryFunction: window.IdeaMapper_entry,
                containerElements: [screen],
              },
            });

            window.wasmModule = instance;
            scriptLoaded.current = true;
          } catch (e) {
            console.error(e);
            console.error(e.stack);
          }
        }

        // Initialize the application
        await init();
      } catch (error) {
        console.error("Error loading scripts:", error);
      }
    };

    loadScripts();
  }, [wasmsrcurl, wasmemscriptenstring]);

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <figure style={{ overflow: "hidden" }} id="qtspinner">
        <div
          style={{
            marginTop: "1.5em",
            lineHeight: "150%",
            textAlign: "center",
          }}
        >
          <img
            src="IdeaMapperLogo.svg"
            width="100%"
            height="100%"
            style={{ display: "block", margin: "auto" }}
            alt=""
          />
          <strong>Please wait while we set up IdeaMapper for you</strong>
          <div id="qtstatus"></div>
          <noscript>
            JavaScript is disabled. Please enable JavaScript to use this
            application.
          </noscript>
        </div>
      </figure>
    </div>
  );
};

export default React.memo(IdeaMapper);

/*import React, { useEffect } from "react";

const IdeaMapper = ({ wasmsrcurl, wasmemscriptenstring }) => {
  useEffect(() => {
    window.initWasm();
  }, [wasmsrcurl, wasmemscriptenstring]); // Add dependencies to re-run if these props change

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <figure style={{ overflow: "hidden" }} id="qtspinner">
        <div
          style={{
            marginTop: "1.5em",
            lineHeight: "150%",
            textAlign: "center",
          }}
        >
          <img
            src="IdeaMapperLogo.svg"
            width="640"
            height="480"
            style={{ display: "block", margin: "auto" }}
            alt=""
          />
          <strong>Please wait while we set up IdeaMapper for you</strong>
          <div id="qtstatus"></div>
          <noscript>
            JavaScript is disabled. Please enable JavaScript to use this
            application.
          </noscript>
        </div>
      </figure>
      {/* <div id="screen"></div> 
    </div>
  );
};

export default React.memo(IdeaMapper);*/
